import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const commonQuestionStyles = theme => ({
  root: {
    width: '100%',
    '& .MuiExpansionPanel-rounded:last-child': {
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '0px',
    },
    '& .MuiExpansionPanel-rounded:first-child': {
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '0px',
    },
  },
  panel: {
    background: 'transparent',
    borderBottom: '1px solid #e5e5e5',
    '& .Mui-expanded p': {
      fontWeight: 'bold',
    },
  },
  heading: {
    fontSize: '16px',
    fontWeight: 'normal',
  },
  summary: {
    '& .MuiExpansionPanelSummary-content': {
      margin: '24px 0',
    },
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  details: {
    [theme.breakpoints.down('xs')]: {
      padding: '8px 24px 24px 0',
    },
    '& p': {
      fontSize: '16px',
    },
  },
});

function CommonQuestion(props) {
  const { classes, question, answer } = props;

  return (
    <div className={classes.root}>
      <ExpansionPanel elevation={0} className={classes.panel}>
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon fontSize="large" />}
          className={classes.summary}
        >
          <Typography className={classes.heading}>{question}</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.details}>
          <Typography>{answer}</Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </div>
  );
}

CommonQuestion.propTypes = {
  classes: PropTypes.object.isRequired,
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
};

export default withStyles(commonQuestionStyles)(CommonQuestion);
